import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MAT_BOTTOM_SHEET_DATA, MatBottomSheetRef } from '@angular/material/bottom-sheet';
import { ButtonModule } from '@components/button';
import { ButtonCtaComponent } from '@components/button-cta/button-cta.component';
import { EventLoggerService } from '@services/event-logger-service';
import { AppWebBridgeService } from '@services/app-web-bridge-service';

@Component({
  selector: 'share-payment-link-shared',
  templateUrl: './share-payment-link-shared.html',
  imports: [CommonModule, ButtonModule, ButtonCtaComponent],
})
export class SharePaymentLinkSharedComponent {
  data = inject<any>(MAT_BOTTOM_SHEET_DATA);
  private readonly bottomSheetRef = inject(MatBottomSheetRef);
  private readonly eventLogger = inject(EventLoggerService);
  private readonly appWebBridgeService = inject(AppWebBridgeService);

  orderSP: number = 0;
  paymentLink: string = '';

  ngOnInit(): void {
    this.orderSP = this.data?.orderSP || 0;
    this.paymentLink = this.data?.paymentLink || '';
    this.eventLogger.cleverTapEvent('pageOpen', JSON.stringify({ pageName: 'payment_link_shared_shown' }));
  }

  async onShareAgain(): Promise<void> {
    this.eventLogger.cleverTapEvent('click', JSON.stringify({ name: 'payment_link_share_again_clicked' }));
    await this.appWebBridgeService.shareTextThroughSupportedApps(this.paymentLink);
  }

  onCopyLink(): void {
    this.eventLogger.cleverTapEvent('click', JSON.stringify({ name: 'payment_link_copy_link_clicked' }));
    navigator.clipboard?.writeText(this.paymentLink);
  }

  closeBottomSheet(): void {
    this.eventLogger.cleverTapEvent('click', JSON.stringify({ name: 'payment_link_shared_closed' }));
    this.bottomSheetRef.dismiss();
  }
}
